<template>
    <div>
      <el-button type="primary" @click="openDialog()">新增风貌</el-button>
  
      <el-table :data="list" style="width: 100%; margin-top: 20px;">
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="remark" label="备注" width="200" />
        <el-table-column prop="image_path" label="图片" width="220" align="center">
          <template slot-scope="scope">
            <el-image
              :src="getFullImageUrl(scope.row.image_path)"
              style="width: 100px; height: 100px;"
              fit="cover"
            />
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="上传时间" width="300" align="center" />
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button size="small" @click="edit(scope.row)">编辑</el-button>
            <el-button size="small" type="danger" @click="remove(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
  
      <el-pagination
        style="margin-top: 20px; text-align: right;"
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="pageSize"
        :current-page.sync="page"
        @current-change="loadLandscapes"
      />
  
      <!-- 弹窗 -->
      <el-dialog :visible.sync="showDialog" title="风貌管理" width="600px">
        <el-form :model="form" label-width="80px">
          <el-form-item label="备注">
            <el-input v-model="form.remark" placeholder="请输入备注" />
          </el-form-item>
          <el-form-item label="图片">
            <input type="file" ref="fileInput" @change="onFileChange" />
            <div v-if="form.imagePreview" style="margin-top: 10px;">
              <el-image
                :src="form.imagePreview"
                style="width: 120px; height: 120px;"
                fit="cover"
              />
            </div>
          </el-form-item>
        </el-form>
        <span slot="footer">
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="primary" @click="save">保存</el-button>
        </span>
      </el-dialog>
    </div>
  </template>
  
  <script>
  import { Message } from "element-ui";
  import {
    getLandscapes,
    addLandscape,
    updateLandscape,
    deleteLandscape,
  } from "@/api/landscape.js";
  
  export default {
    name: "Landscape",
    data() {
      return {
        list: [],
        total: 0,
        page: 1,
        pageSize: 5,
        showDialog: false,
        form: {
          id: null,
          remark: "",
          image: null,
          imagePreview: null,
        },
      };
    },
    created() {
      this.loadLandscapes();
    },
    methods: {
      async loadLandscapes() {
        try {
          const res = await getLandscapes({
            page: this.page,
            pageSize: this.pageSize,
          });
          if (res.status === 200) {
            this.list = res.data.data.list || [];
            this.total = res.data.data.total || 0;
          } else {
            Message.error(res.msg || "获取风貌列表失败");
          }
        } catch (err) {
          Message.error("请求异常");
        }
      },
      openDialog() {
        this.resetForm();
        this.showDialog = true;
      },
      edit(row) {
        this.form = {
          id: row.id,
          remark: row.remark,
          image: null,
          imagePreview: this.getFullImageUrl(row.image_path),
        };
        this.showDialog = true;
      },
      closeDialog() {
        this.resetForm();
        this.showDialog = false;
      },
      onFileChange(e) {
        const file = e.target.files[0];
        this.form.image = file;
        this.form.imagePreview = URL.createObjectURL(file);
      },
      async save() {
        try {
          const formData = new FormData();
          if (this.form.remark) formData.append("remark", this.form.remark);
          if (this.form.image) formData.append("image", this.form.image);
  
          let res;
          if (this.form.id) {
            formData.append("id", this.form.id);
            res = await updateLandscape(formData);
          } else {
            res = await addLandscape(formData);
          }
  
          if (res.status === 200) {
            Message.success("保存成功");
            this.showDialog = false;
            this.loadLandscapes();
          } else {
            Message.error(res.msg || "保存失败");
          }
        } catch (err) {
          Message.error("请求异常");
        }
      },
      getFullImageUrl(imagePath) {
      return this.$serverUrl + imagePath;
    },
      async remove(id) {
        try {
          const formData = new FormData();
          formData.append("id", id);
  
          const res = await deleteLandscape(formData);
          if (res.status === 200) {
            Message.success("删除成功");
            this.loadLandscapes();
          } else {
            Message.error(res.msg || "删除失败");
          }
        } catch (err) {
          Message.error("请求异常");
        }
      },
      resetForm() {
        this.form = {
          id: null,
          remark: "",
          image: null,
          imagePreview: null,
        };
        if (this.$refs.fileInput) {
          this.$refs.fileInput.value = "";
        }
      },
    },
  };
  </script>
  